import { takeEvery, put, call, takeLatest } from "redux-saga/effects";
import {
  FETCH_PROJECT,
  FETCH_CLIENT_PROJECT_SERVICE,
  FETCH_CLIENT_PROJECT_DROPDOWN,
  FETCH_CLIENT_PROJECT_DROPDOWN_CLEAR,
  CHANGE_PROJECT_STATUS,
  CHANGE_PROJECT_STATUS_SUCCESS,
  CHANGE_PROJECT_STATUS_FAILURE,
  CREATE_PROJECT_REQUEST,
  DELETE_CLIENT_PROJECT,
  FETCH_MODULE_PROJECT_DROPDOWN,
} from "./actionTypes";
import * as types from './actionTypes';
import {
  fetchProject,
  fetchProjectSuccess,
  fetchProjectFailure,
  fetchClientProjectService,
  fetchClientProjectServiceSuccess,
  fetchClientProjectServiceFailure,
  fetchClientProjectDropdown,
  fetchClientProjectDropdownSuccess,
  fetchClientProjectDropdownFailure,
  fetchClientProjectDropdownClear,
  changeProjectStatus,
  changeProjectStatusSuccess,
  changeProjectStatusFailure,
  createProjectSuccess,
  createProjectFailure,
  deleteClientProjectSuccess,
  deleteClientProjectFailure,
  fetchModuleProject,
  fetchModuleProjectSuccess,
  fetchModuleProjectFailure,
} from "./actions";
import { get, post, update, del } from "../../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Project
function* fetchProjectSaga({ payload: { unitId, create_by } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    formData.append("create_by", create_by);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_PROJECT, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve project!");
    }
    yield put(fetchProjectSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchProjectFailure(error.message));
  }
}

function* fetchClientProjectServiceSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_CLIENT_PROJECT_DROPDOWN, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve client project service data!");
    }
    yield put(fetchClientProjectServiceSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchClientProjectServiceFailure(error.message));
  }
}

function* fetchClientProjectDropdownSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_CLIENT_PROJECT_DROPDOWN, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve client project dropdown data!");
    }
    yield put(fetchClientProjectDropdownSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchClientProjectDropdownFailure(error.message));
  }
}

function* fetchClientProjectDropdownClearSaga(action) {
  fetchClientProjectDropdownClear();
}

function* changeProjectStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_CHANGE_PROJECT_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update head status!');
    }

    yield put({ type: types.CHANGE_PROJECT_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_PROJECT_STATUS_FAILURE, payload: error });
  }
}

// Create Project Saga
function* createProjectSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_SAVE_PROJECT, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Project saved successfully!",
      });
      yield put(createProjectSuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchProject(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createProjectFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the deduction",
    });
    yield put(createProjectFailure(error.message));
  }
}

function* deleteClientProjectSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_DELETE_CLIENT_PROJECT, action.payload);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: response.message || "Project deleted successfully!",
      });
      yield put(deleteClientProjectSuccess(response));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to delete deduction!",
      });
      yield put(deleteClientProjectFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Delete Project Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while deleting the deduction",
    });
    yield put(deleteClientProjectFailure(error.message));
  }
}

function* fetchModuleProjectSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_MODULE_PROJECT_DROPDOWN, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve client module service data!");
    }
    yield put(fetchModuleProjectSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchModuleProjectFailure(error.message));
  }
}

function* getProjectServiceMappingSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_GET_PROJECT_SERVICE_MAPPING,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(
        response?.message || "Failed to fetch project service mapping!"
      );
    }

    yield put({
      type: types.GET_PROJECT_SERVICE_MAPPING_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error("Get Project Service Mapping Error:", error);
    yield put({
      type: types.GET_PROJECT_SERVICE_MAPPING_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}

function* getProjectServiceListSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_GET_PROJECT_SERVICE_MAPPING,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(
        response?.message || "Failed to fetch project service list!"
      );
    }

    yield put({
      type: types.GET_PROJECT_SERVICE_LIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error("Get Project Service List Error:", error);
    yield put({
      type: types.GET_PROJECT_SERVICE_LIST_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}

/* SAVE project–service mapping */
function* saveProjectServiceMappingSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_PROJECT_SERVICE_MAPPING,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(
        response?.message || "Failed to save project service mapping!"
      );
    }

    yield put({
      type: types.SAVE_PROJECT_SERVICE_MAPPING_SUCCESS,
      payload: response,
    });

    Swal.fire("Success", response.message, "success");
  } catch (error) {
    console.error("Save Project Service Mapping Error:", error);
    yield put({
      type: types.SAVE_PROJECT_SERVICE_MAPPING_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}

function* getProjectStatusBillingSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_GET_PROJECT_STATUS_BILLING,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch project status billing!");
    }

    yield put({
      type: types.GET_PROJECT_STATUS_BILLING_SUCCESS,
      payload: response.data,
    });

  } catch (error) {
    console.error("Get Project Status Billing Error:", error);
    yield put({
      type: types.GET_PROJECT_STATUS_BILLING_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}

function* saveProjectStatusBillingSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_PROJECT_STATUS_BILLING,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save project status billing!");
    }

    yield put({
      type: types.SAVE_PROJECT_STATUS_BILLING_SUCCESS,
      payload: response,
    });

    Swal.fire("Success", response.message, "success");

  } catch (error) {
    console.error("Save Project Status Billing Error:", error);
    yield put({
      type: types.SAVE_PROJECT_STATUS_BILLING_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}

function* changeProjectBillingStatusSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_CHANGE_PROJECT_BILLING_STATUS,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to change billing status!");
    }

    yield put({
      type: types.CHANGE_PROJECT_BILLING_STATUS_SUCCESS,
      payload: response,
    });

    Swal.fire("Success", response.message, "success");

  } catch (error) {
    console.error("Change Billing Status Error:", error);
    yield put({
      type: types.CHANGE_PROJECT_BILLING_STATUS_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}

export function* getProserviceListSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_GET_PROSERVICE_LIST,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch project service list!");
    }

    yield put({
      type: types.GET_PROSERVICE_LIST_SUCCESS,
      payload: response.data,
    });

  } catch (error) {
    console.error("Get Proservice List Error:", error);
    yield put({
      type: types.GET_PROSERVICE_LIST_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}

export function* getOrgProjectCountSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_GET_ORG_PROJECT_COUNT,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(
        response?.message || "Failed to fetch org project count!"
      );
    }

    yield put({
      type: types.GET_ORG_PROJECT_COUNT_SUCCESS,
      payload: response.data ? response.data[0].project_count : 0,
    });
  } catch (error) {
    console.error("Get Org Project Count Error:", error);
    yield put({
      type: types.GET_ORG_PROJECT_COUNT_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}

// Watcher Saga
function* timesheetSetupProjectSaga() {
  yield takeEvery(FETCH_PROJECT, fetchProjectSaga);    
  yield takeEvery(FETCH_CLIENT_PROJECT_SERVICE, fetchClientProjectServiceSaga); 
  yield takeEvery(FETCH_CLIENT_PROJECT_DROPDOWN, fetchClientProjectDropdownSaga); 
  yield takeEvery(FETCH_CLIENT_PROJECT_DROPDOWN_CLEAR, fetchClientProjectDropdownClearSaga);
  yield takeEvery(CHANGE_PROJECT_STATUS, changeProjectStatusSaga);
  yield takeEvery(CREATE_PROJECT_REQUEST, createProjectSaga);
  yield takeEvery(DELETE_CLIENT_PROJECT, deleteClientProjectSaga);
  yield takeEvery(FETCH_MODULE_PROJECT_DROPDOWN, fetchModuleProjectSaga); 
  yield takeLatest(
    types.GET_PROJECT_SERVICE_MAPPING_REQUEST,
    getProjectServiceMappingSaga
  );
   yield takeLatest(
    types.GET_PROJECT_SERVICE_LIST_REQUEST,
    getProjectServiceListSaga
  );
  yield takeLatest(
    types.SAVE_PROJECT_SERVICE_MAPPING_REQUEST,
    saveProjectServiceMappingSaga
  );
  yield takeLatest(types.GET_PROJECT_STATUS_BILLING_REQUEST, getProjectStatusBillingSaga);
  yield takeLatest(types.SAVE_PROJECT_STATUS_BILLING_REQUEST, saveProjectStatusBillingSaga);
  yield takeLatest(types.CHANGE_PROJECT_BILLING_STATUS_REQUEST, changeProjectBillingStatusSaga);
  yield takeLatest(types.GET_PROSERVICE_LIST_REQUEST, getProserviceListSaga);
  yield takeLatest( types.GET_ORG_PROJECT_COUNT_REQUEST,  getOrgProjectCountSaga);
}

export default timesheetSetupProjectSaga;
